import { ECrashes } from './interfaces';
import type { AttributesLayoutHelper } from '#lib/components/Attributes.types.js';

// --- Helpers used by attributesColumns ---

const attributesCrashes: AttributesLayoutHelper = {
	title: { accessorKey: 'id', cell: () => 'Fatal crash' },
	subheaders: [[{ accessorKey: 'road_name' }, { accessorKey: 'county' }]],
	body: [
		{ accessorKey: 'year', header: () => 'Crash year' },
		{ accessorKey: 'fatal_count', header: () => 'Number of fatalities' }
	],
	table: [
		{
			accessorKey: 'road_func_class',
			header: () => 'Roadway functional classification',
			cell: (info) => (info || 'Unknown') as string
		},
		{ accessorKey: 'veh_involved_count', header: () => 'Number of vehicles involved' },
		{
			accessorKey: 'date',
			header: () => 'Date',
			cell: (info) => new Date(info as string).toLocaleDateString()
		}
	]
};

const attributesUploadedCrashes: AttributesLayoutHelper = {
	title: { accessorKey: 'id', cell: () => 'Uploaded crash data' },
	subheaders: [[{ header: () => 'Severity', accessorKey: 'Severity' }]],
	body: [{ header: () => 'Fatalities', accessorKey: 'Fatalities' }],
	table: [
		{
			header: () => 'Date of Incident',
			accessorKey: 'Date of Incident',
			cell: (info) => new Date(info as string).toLocaleDateString()
		},
		{ header: () => 'Manner of Collision', accessorKey: 'Manner of Collision' },
		{ header: () => 'Location Type', accessorKey: 'Location Type' },
		{ header: () => 'Surface Condition', accessorKey: 'Surface Condition' }
	]
};

export const attributesColumns: Record<string, AttributesLayoutHelper> = {
	[ECrashes.CrashesCircle]: attributesCrashes,
	[ECrashes.UploadedCrashes]: attributesUploadedCrashes
};
